<div class="header" *ngIf="mapTabEnabled">
  {{showHeader()}}
</div>
<ion-segment [value]="currentSegment" [scrollable]="true" (ionChange)="segmentChanged($event)">
  <ion-segment-button [disabled]="!mapTabEnabled" value="location">
    <ion-label>{{ 'Standortdetails' | translate }}</ion-label>
  </ion-segment-button>
  <ion-segment-button [disabled]="!mapTabEnabled" value="contact">
    <ion-label>{{ 'Kontakt' | translate }}</ion-label>
  </ion-segment-button>
  <ion-segment-button [disabled]="!mapTabEnabled" value="history">
    <ion-label>{{ 'Verlauf' | translate }}</ion-label>
  </ion-segment-button>
  <ion-segment-button [disabled]="!mapTabEnabled" value="status">
    <ion-label>{{ 'Status' | translate }}</ion-label>
  </ion-segment-button>
  <ion-segment-button *ngIf="!smallDevice" [disabled]="!mapTabEnabled" value="gps">
    <ion-label>{{ 'GPS' | translate }}</ion-label>
  </ion-segment-button>
  <ion-segment-button *ngIf="!smallDevice" [disabled]="!mapTabEnabled" value="notizen">
    <ion-label>{{ 'Notizen' | translate }}</ion-label>
  </ion-segment-button>
  <ion-segment-button *ngIf="!smallDevice" [disabled]="!mapTabEnabled || !enableQuittieren" value="quittieren">
    <ion-label>{{ 'Acknowledge' | translate }}</ion-label>
  </ion-segment-button>
</ion-segment>

<ion-segment *ngIf="smallDevice" [value]="currentSegment" [scrollable]="true" (ionChange)="segmentChanged($event)">
  <ion-segment-button [disabled]="!mapTabEnabled" value="gps">
    <ion-label>{{ 'GPS' | translate }}</ion-label>
  </ion-segment-button>
  <ion-segment-button [disabled]="!mapTabEnabled" value="notizen">
    <ion-label>{{ 'Notizen' | translate }}</ion-label>
  </ion-segment-button>
  <ion-segment-button [disabled]="!mapTabEnabled || !enableQuittieren" value="quittieren">
    <ion-label>{{ 'Quittieren' | translate }}</ion-label>
  </ion-segment-button>
</ion-segment>

<div class="content" *ngIf="mapTabEnabled">
  <page-location-details [showHeader]="false" *ngIf="currentSegment === 'location'"></page-location-details>
  <page-contact-details [showHeader]="false" *ngIf="currentSegment === 'contact' && api._user.profile.role !== 'relationOnly'"></page-contact-details>
  <app-page-contacts [showHeader]="false" *ngIf="currentSegment === 'contact' && api._user.profile.role === 'relationOnly'"></app-page-contacts>
  <page-history [showHeader]="false" *ngIf="currentSegment === 'history'"></page-history>
  <page-status [showHeader]="false" *ngIf="currentSegment === 'status'"></page-status>
  <page-gps [showHeader]="false" *ngIf="currentSegment === 'gps'"></page-gps>
  <app-page-note [showHeader]="false" *ngIf="currentSegment === 'notizen'"></app-page-note>
  <page-quit [showHeader]="false" *ngIf="currentSegment === 'quittieren' && dataType === 'patient'"></page-quit>
  <page-quit-technical [showHeader]="false" *ngIf="currentSegment === 'quittieren' && dataType !== 'patient'"></page-quit-technical>
</div>
